/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResellerCustomDomain { 
    account_id: string;
    console_subdomain: string;
    created_at: string;
    custom_domain_root: string;
    dns_configuration?: object;
    email_verification?: object;
    id: string;
    partner_zone_domain?: string | null;
    partner_zone_enabled: boolean;
    status: ResellerCustomDomain.StatusEnum;
    updated_at: string;
}
export namespace ResellerCustomDomain {
    export type StatusEnum = 'started' | 'dns_verified' | 'email_verified' | 'active';
    export const StatusEnum = {
        STARTED: 'started' as StatusEnum,
        DNS_VERIFIED: 'dns_verified' as StatusEnum,
        EMAIL_VERIFIED: 'email_verified' as StatusEnum,
        ACTIVE: 'active' as StatusEnum
    };
}


